import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qs from 'qs'
import {Button} from 'react-weui'
import {Page} from '../../../components'
import {WKError} from '../../../components'
import {WKPreload} from '../../../components/wk'
import InviteBanner from './InviteBanner'
import InviteAccepted from './InviteAccepted'
import {getJsonFromUrl} from '../../../utils'


class InviteNewAcceptPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initialized: false
        }
        this.acceptClickHandle = this.acceptClickHandle.bind(this)
    }

    componentDidMount() {
        let params = location.search
        let paramJson = getJsonFromUrl()
        this.setState(paramJson)
        axios.get(`/api/marketing/channel_invitation/accept_init${params}`)
            .then(res => {
                let code = res.data && res.data.code
                if (code === 0) {
                    let {inviter} = res.data.data
                    this.setState({inviter, initialized: true})
                } else {
                    location.href = `/specials/app/invite_new${params}`
                }
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.status && error.response.status !== 401) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '服务器出现拥挤了，请联系管理员',
                            href: '/?st=app_inviter_accept_error',
                            btn: '去首页看看'
                        }
                    })
                }
            })
    }

    acceptClickHandle() {
        const {invite_code} = this.state
        if (invite_code) {
            axios.post(`/api/marketing/channel_invitation/accept`, qs.stringify({invite_code}))
                .then(res => {
                    let code = res.data && res.data.code
                    if (code === 0) {
                        location.href = '/specials/app/invite_success'
                    } else {
                        this.page.showAlert(res.data.msg)
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (error.response && error.response.status) {
                        this.page.showAlert('服务器出现拥挤了，请联系管理员')
                    }
                })
        } else {
            this.page.showAlert('分享地址有误，请重试')
        }

    }

    render() {
        const {initialized, inviter} = this.state
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="invite-accept-page">
                    <WKError/>
                </div>
            )
        }

        if (!initialized) {
            return <Page parent={this} className="invite-accept-page">
                <WKPreload/>
            </Page>
        }

        return <Page parent={this} className="invite-accept-page">
            <InviteBanner/>
            <div className="invite-accept-content">
                <Button type="primary" className="invite-get-btn" onClick={this.acceptClickHandle}>免费领取</Button>
                <InviteAccepted inviter={inviter}/>
            </div>
        </Page>
    }
}

export default connect((state) => ({
    error: state.error,
}))(InviteNewAcceptPage)



// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteNewAcceptPage.js